import { Observable } from 'rxjs/Observable';
import { EventSource } from './eventSource';

import { nullSorter } from './sort';
export interface Faq {
    answer?: string;
    category: string;
    default: boolean;
    faqId: string;
    key: string;
    question: string;
    sortKey?: number;
}

import { Photo } from './interfaces';

export class EventFaq {

    private es: EventSource;

    constructor(eventSource: EventSource) {
        this.es = eventSource;
    }

    public observeFaqNote(): Observable<string> {
        return this.es.pluckData(this.es.observeFaqPage(), ['note']);
    }

    public observeFaqs() {
        return this.es.pluckData(this.es.observeFaqPage(), ['faqs'])
        .map(faq => Object.keys(faq).map((key, idx) => {
            if (faq[key].answer) {
                faq[key].key = key;
                faq[key].default = !!faq[key].default;
                faq[key].sortKey = (faq[key].sortKey && !isNaN(parseInt(faq[key].sortKey))) ? parseInt(faq[key].sortKey) : idx;
                return faq[key] 
            }
        }).filter(x => x)).map(data => data.sort(nullSorter))
    }

    public observePrimaryFaqPhoto(): Observable<Photo> {
        return this.es.observePrimaryPhoto(this.es.observeFaqPage());
    }
    
    public observePrimaryFaqPhotoHorizontal(): Observable<Photo> {
        return this.es.observePrimaryPhotoHorizontal(this.es.observeFaqPage());
    }
}
